import { Button } from "@blueprintjs/core"
import classNames from "classnames"
import { SquareParking } from "lucide-react"
import { useTranslation } from "react-i18next"

type AutohofsSwitchProps = {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  /** Placement; the default is the old fixed spot for maps without a column */
  className?: string
}

const AutohofsSwitch = ({
  checked,
  onCheckedChange,
  className = "absolute left-[10px] top-[150px] z-10",
}: AutohofsSwitchProps) => {
  const { t } = useTranslation()
  return (
    <div className={className}>
      <Button
        id="toggle-autohofs"
        active={checked}
        className={classNames(
          "!h-[30px] !min-h-[30px] !w-[30px] !min-w-[30px] !p-0 dark:text-white",
          checked
            ? "!bg-[#1565c0] !text-white hover:!bg-[#11519a] dark:!bg-[#1565c0]"
            : "!text-[#5f6b7c] hover:!text-[#5f6b7c] dark:bg-gray-700 dark:!text-white",
        )}
        icon={<SquareParking size={16} strokeWidth={2.25} />}
        onClick={() => onCheckedChange(!checked)}
        title={
          checked
            ? t("maps.autohofsSwitch.hide")
            : t("maps.autohofsSwitch.show")
        }
      />
    </div>
  )
}

export default AutohofsSwitch
